import * as _ from 'lodash';

export default function clone(obj: any) {
  return _.cloneDeep(obj);
}


// WEBPACK FOOTER //
// ./src/services/util/Copy.ts